import styles from "./BasicAccordionUnit.module.scss";
interface Panel {
  title: any;
  description: any;
  isComponent?: boolean;
}
interface AccordionProps {
  panels: Panel[];
  className?: string;
  hideArrow?: boolean;
  defaultOpen?: boolean;
  titleClass?: string;
  contentClass?: string;
  accordionClass?: string;
  name?: string;
  onClick?: any;
  disableClick?: boolean;
}

const BasicAccordionUnit = (props: AccordionProps) => {
  const {
    panels,
    className = "",
    hideArrow,
    titleClass,
    contentClass,
    defaultOpen = false,
    name = "AccordionBasic",
    onClick,
    disableClick = false,
  } = props;

  return (
    <div className={`${styles.accordionContainer} ${className}`}>
      {panels?.map((accordianData, index) => (
        <div
          className={`${styles.accordianList} ${disableClick ? styles.disabled : ""}`}
          key={`accordian_${accordianData?.title}`}
          onClick={() => {
            !disableClick && onClick && onClick(index, accordianData);
          }}
        >
          <input
            type="checkbox"
            name={`accordion${name}`}
            id={`checkbox${name}${index}`}
            defaultChecked={defaultOpen}
          />
          <label
            htmlFor={`checkbox${name}${index}`}
            className={`${styles.accordionPanel} ${titleClass ? titleClass : ""}`}
          >
            <span className={styles.titleAccordian}>{accordianData?.title}</span>
            <span className={`${styles.arrow} ${hideArrow ? styles.hideArrow : ""}`}></span>
          </label>
          {accordianData?.description && (
            <div className={styles.pannelDetail} aria-label="Panel Details">
              <div
                className={`${styles.pannelContent} ${contentClass ? contentClass : ""}`}
                dangerouslySetInnerHTML={{ __html: accordianData?.description }}
                aria-label="Panel Details"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default BasicAccordionUnit;
